<template>
  <modal
    name="send-test"
    height="auto"
    width="400"
  >
    <div class="p-4">
      <modal-title>
        Send Test
      </modal-title>
      <div class="form-group">
        <label>Alert Individual Users</label>
        <multiselect
          v-model="testUsers"
          :options="users"
          :internal-search="false"
          :allow-empty="true"
          :searchable="true"
          :multiple="true"
          :show-labels="false"
          class="multiselect"
          style="cursor:pointer"
          select-label="Select"
          label="name"
          track-by="id"
          @search-change="delayGetUsers"
        >
          <span
            slot="option"
            slot-scope="prop"
          >
            {{ prop.option.name }} ({{ prop.option.email }})
          </span>
          <span
            slot="placeholder"
            class="multiselect__placeholder"
          >
            Select users
          </span>
        </multiselect>
      </div>

      <div class="d-flex mt-3 border-top pt-3">
        <button
          class="btn btn-outline-danger ml-auto"
          @click="$modal.hide('send-test')"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary ml-2"
          @click="sendTest"
        >
          Send
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import {debounce} from '@/helpers'
import {search} from '@/helpers'
import ModalTitle from '@/components/ModalTitle'

export default {
  data () {
    return {
      users: [],
      testUsers: [],
    }
  },

  components: {
    ModalTitle,
  },

  mounted () {
    this.testUsers.push(this.$login.getUser())
  },

  methods: {
    sendTest () {
      this.$emit('send', this.testUsers)
    },

    delayGetUsers: debounce(function (query) {
      search('users', query).then((response) => {
        this.users = response.data
      })
    }, 200),
  },
}
</script>
